<template>
  <div class="embed" :title="caption">
    <div class="embed__content tiktok" v-html="content" />
    <div class="embed__caption">{{ caption }}</div>
  </div>
</template>

<script>
import { network } from '~/constants/embedded-social-scripts';
import { appendEmbeddedSocialScript } from '~/utils/append-embedded-social-script';

export default {
  name: 'PostContentEmbedTiktok',
  props: {
    content: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: '',
    },
  },
  mounted() {
    appendEmbeddedSocialScript(network.tiktok);
  },
};
</script>

<style lang="postcss" scoped>
@import './styles.css';

.tiktok {
  max-width: 325px;
  border-radius: 8px;

  &::v-deep(blockquote) {
    margin: 0;
  }

  @media (--small-vp) {
    margin: auto;
  }
}
</style>
